module.exports = __webpack_public_path__ + "assets/img/home-2025-school-logo.263a8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-2025-school-logo.png
// module id = 583
// module chunks = 1